<div class="col-12 lbl-stacked ubo-source-of-wealth">
	<mat-label>
		Source of Wealth declared by each UBO
		<small
			><br /><i
				>Collected in Legal Person Information. Change it there and it
				updates here.</i
			></small
		>
	</mat-label>

	<ng-container *ngIf="beneficialOwners.length; else nothingDeclared">
		<div
			class="ubo-source-of-wealth__person"
			*ngFor="let beneficialOwner of beneficialOwners"
		>
			<strong>{{ beneficialOwner.name }}</strong>
			<p class="ubo-source-of-wealth__answer">
				{{ beneficialOwner.sourceOfWealth }}
			</p>
			<p
				class="ubo-source-of-wealth__detail"
				*ngIf="beneficialOwner.detail"
			>
				<small>{{ beneficialOwner.detail }}</small>
			</p>
		</div>
	</ng-container>
</div>

<ng-template #nothingDeclared>
	<p class="ubo-source-of-wealth__empty">
		<small
			><i
				>No beneficial owner has declared a source of wealth yet. Add
				one against each UBO in Legal Person Information.</i
			></small
		>
	</p>
</ng-template>
